import { Component, OnInit } from '@angular/core';
import { IesterService } from '@heda/core-hospital-ui';

@Component({
  template: ` <div></div> `,
})
export class IesterComponent implements OnInit {
  constructor(private iesterService: IesterService) {}

  ngOnInit(): void {
    this.iesterService.open('', '_self');
  }
}
